<template>
  <div>
    <div class="v-label mb-2">Search Results (Experimental)</div>
    <v-btn-toggle mandatory tile v-model="productGrid" @change="setGrid()">
      <v-btn :value="true">
        <v-icon>mdi-grid</v-icon>Grid
      </v-btn>
      <v-btn :value="false">
        <v-icon>mdi-view-list</v-icon>List
      </v-btn>
    </v-btn-toggle>
  </div>
</template>

<script>
import { mapActions } from "vuex";

export default {
  name: "ProductViewToggle",
  data() {
    return {
      productGrid: this.$store.getters.retrieveProductGrid
    };
  },
  methods: {
    ...mapActions(["setProductGrid"]),

    async setGrid() {
      await this.setProductGrid(this.productGrid);
    }
  }
};
</script>

<style lang="sass" scoped>
</style>